import React, { useState, useEffect } from 'react'
import Table from '../components/payments/Table'
import { payColumns } from '../../utilities/utility'
import PayoutCards from '../components/payments/PayoutCards'
import axios from 'axios'

export default function Payouts() {
    const [payouts, setPayouts] = useState([])
    useEffect(() => {
        const fetchPayOut = async () => {
            const { data } = await axios.get("api/admintochefpayments/")
            setPayouts(data.payouts)
        }
        fetchPayOut()
    }, [])
    return (
        <div className="wrapper wrapper-content">
            <PayoutCards />
            <Table title="Payouts" data={payouts} columns={payColumns} flag={true} />
        </div>
    )
}
